import React from "react";
import { PDFExport } from "@progress/kendo-react-pdf";

import Page48hMain from "./PageMain_V2/PageMain";
import Page48hTestInfo from "./PageMain_V2/PageTestInfo";
import Page48hChart from "./PageMain_V2/PageChart";
import Page48hRadonTable from "./PageMain_V2/PageRadonTable";
import PageAdditional from "./Page48h/PageAdditional";
import PageRecommendations from "./Page48h/PageRecommendations";
import PageUncertainty from "./Page48h/PageUncertainty";
import { PDF_REPORT_FONT_FAMILY } from "./pdfFontSetup";
import "./pdfFont.css";

const pageStyle = {
  width: "612px",
  height: "792px",
  boxSizing: "border-box",
  padding: "25px 25px 5px",
  border: "none",
  backgroundColor: "white",
  fontFamily: PDF_REPORT_FONT_FAMILY,
};

const ForPdf = ({
  pdfExportComponent,
  reportDetails,
  reportChartRadonValue,
  pageAdditional,
  pageRecommendations,
  pageUncertainty,
}) => {
  const is48h = reportDetails?.req_type === "RPT_48H" || reportDetails?.measurement_duration === "48 Hours";

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        opacity: 0,
        pointerEvents: "none",
        zIndex: -1,
      }}
    >
      <PDFExport paperSize="Letter" forcePageBreak=".page-break" ref={pdfExportComponent}>
        <div id="pdfRoot" className="pdf-font-root">
          {/* Base 3 Pages: Always Visible */}
          <div className="pdf-body" style={pageStyle}>
            <Page48hMain
              reportDetails={reportDetails}
              reportChartRadonValue={reportChartRadonValue}
            />
          </div>

          <div className="pdf-body page-break" style={pageStyle}>
            <Page48hTestInfo reportDetails={reportDetails} />
          </div>

          <div className="pdf-body page-break" style={pageStyle}>
            <Page48hChart
              reportDetails={reportDetails}
              reportChartRadonValue={reportChartRadonValue}
            />
          </div>

          {/* 48hr Pages */}
          {is48h && (
            <>
              <div className="pdf-body page-break" style={pageStyle}>
                <Page48hRadonTable
                  reportDetails={reportDetails}
                  reportChartRadonValue={reportChartRadonValue}
                />
              </div>

              {pageAdditional && (
                <div className="pdf-body page-break" style={pageStyle}>
                  <PageAdditional reportDetails={reportDetails} />
                </div>
              )}

              {pageRecommendations && (
                <div className="pdf-body page-break" style={pageStyle}>
                  <PageRecommendations reportDetails={reportDetails} />
                </div>
              )}

              {pageUncertainty && (
                <div className="pdf-body page-break" style={pageStyle}>
                  <PageUncertainty reportDetails={reportDetails} />
                </div>
              )}
            </>
          )}
        </div>
      </PDFExport>
    </div>
  );
};

export default ForPdf;
